<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden" style="width: 95%; margin: 0 auto;">
    <h1 class="text-center lifedi-color m-3">
        รายการทางการเงิน
    </h1>
    <h3 class="text-center lifedi-color mt-2 mb-4">
        <span *ngIf="accountId === '038-308312-5'">
          บัญชีคณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย
        </span>
        <span *ngIf="accountId === '138-177454-2'">
          บัญชีบริษัทผลิตภัณฑ์นวัตกรรมจามจุรี จำกัด
        </span>
      </h3>

    <div class="row d-flex pb-4 justify-content-center">
        <input type="text" class="form-control search" placeholder="ค้นหารายการทางการเงิน" name="searchWorkshop"
            [(ngModel)]="search" (keyup)="searching()" style="width: 20%;">

        <button mat-button (click)="paymentReport()"
            style="position: absolute; right: 6%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:#FFFFFF">
            รายงานการเงิน <img src="assets/direct-download-white.png"
                style="width: 20px; margin-bottom: 3px; margin-left: 2px;" alt="">
        </button>

        <button mat-button (click)="uploadSignature()"
            style="position: absolute; left: 6%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:#FFFFFF">
            อัปโหลดลายเซ็น
            <!-- <img src="assets/direct-download-white.png" style="width: 20px; margin-bottom: 3px; margin-left: 2px;" alt=""> -->
        </button>
    </div>

    <!-- not search -->
    <nz-table *ngIf="!isSearch" #groupingTable [nzData]="allPayment" nzBordered nzSize="large"
        class="table table-striped">
        <thead>
            <tr>
                <th class="text-center" [nzSortFn]="sortPaymentIDFn">รหัสรายการ</th>
                <th class="text-center" [nzFilters]="filterType" [nzFilterFn]="typeFilterFn">หมวดหมู่</th>
                <th class="text-center">Username</th>
                <th class="text-center" [nzSortFn]="sortDateFn">วันที่ชำระเงิน</th>
                <th class="text-center" [nzFilters]="filterStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
                <th class="text-center">รายละเอียดรายการ</th>
                <th class="text-center">ผู้ตรวจสอบ</th>
            </tr>

        </thead>
        <tbody>
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.PAYMENT_ID }}</td>
                <td class="text-center">{{ data.TYPE }}</td>
                <td class="text-center">{{ data.USERNAME }}</td>
                <td class="text-center">{{ data.PAYMENT_DATE | date }}</td>

                <td class="text-center" *ngIf="data.STATUS_PAYMENT === 'success'">
                    <p class="text-success">สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS_PAYMENT === 'waiting_confirm'">
                    <p class="lifedi-color">รอการตรวจสอบ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS_PAYMENT === 'reject'">
                    <p class="text-danger">ไม่สำเร็จ</p>
                </td>

                <td class="text-center">
                    <a (click)="verify(data.PAYMENT_ID)">
                        <img src="assets/employee.png" alt="" width="25px">
                    </a>
                </td>

                <td class="text-center">{{ data.APPROVE_NAME }}</td>
            </tr>
        </tbody>
    </nz-table>
    <!-- not search -->

    <!-- search -->
    <nz-table *ngIf="isSearch" #groupingTable [nzData]="listOfData" nzBordered nzSize="large"
        class="table table-striped">
        <thead>
            <tr>
                <th class="text-center" [nzSortFn]="sortPaymentIDFn">รหัสรายการ</th>
                <th class="text-center" [nzFilters]="filterType" [nzFilterFn]="typeFilterFn">หมวดหมู่</th>
                <th class="text-center">Username</th>
                <th class="text-center" [nzSortFn]="sortDateFn">วันที่ชำระเงิน</th>
                <th class="text-center" [nzFilters]="filterStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
                <th class="text-center">รายละเอียดรายการ</th>
                <th class="text-center">ผู้ตรวจสอบ</th>
            </tr>

        </thead>
        <tbody>
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.PAYMENT_ID }}</td>
                <td class="text-center">{{ data.TYPE }}</td>
                <td class="text-center">{{ data.USERNAME }}</td>
                <td class="text-center">{{ data.PAYMENT_DATE | date }}</td>

                <td class="text-center" *ngIf="data.STATUS_PAYMENT === 'success'">
                    <p class="text-success">สำเร็จ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS_PAYMENT === 'waiting_confirm'">
                    <p class="lifedi-color">รอการตรวจสอบ</p>
                </td>
                <td class="text-center" *ngIf="data.STATUS_PAYMENT === 'reject'">
                    <p class="text-danger">ไม่สำเร็จ</p>
                </td>

                <td class="text-center">
                    <a (click)="verify(data.PAYMENT_ID)">
                        <img src="assets/employee.png" alt="" width="25px">
                    </a>
                </td>

                <td class="text-center">{{ data.APPROVE_NAME }}</td>
            </tr>
        </tbody>
    </nz-table>
    <!-- search -->

    <div *ngIf="isLoading">
        <div
            style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
        </div>
        <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
    </div>

</div>